import { API_URL } from "constants/ApiUrl";
import fetch from "../auth/FetchInterceptor";

const AgentService = {};

AgentService.getProfile = function () {
  const url = `${API_URL}/api/agent/profile`;
  return fetch({
    url: url,
    method: "get",
    headers: {
      "Content-Type": "application/json",
    },
  });

};
AgentService.getConversations = function (id) {
  const url = `${API_URL}/api/messages/conversations/Agent/${id}`;
  return fetch({
    url: url,
    method: "get",
    headers: {
      "Content-Type": "application/json",
    },
  });

};
AgentService.sendMessage = function (payload) {
  const url = `${API_URL}/api/messages/send`;
  console.log(payload);

  return fetch(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(payload),
  });
};


export default AgentService;
